import { ReactComponent as CheckedIcon } from '@assets/components/checkbox/checked.svg';
import { ReactComponent as IndeterminateIcon } from '@assets/components/checkbox/indeterminate.svg';
import { Icon, Spinner } from '@chakra-ui/react';
import { CheckedState } from '@zag-js/checkbox';

export function CheckboxIndicator({
  checked = false,
  loading = false,
}: Readonly<{ checked?: CheckedState; loading?: boolean }>) {
  if (loading) {
    return <Spinner boxSize="16px" color="neutral.white" />;
  }

  switch (checked) {
    case 'indeterminate':
      return <Icon as={IndeterminateIcon} />;
    case true:
      return <Icon as={CheckedIcon} />;
    default:
      return null;
  }
}
